import React, { Component } from 'react';
import axios from 'axios';
import { Configurations } from '../../../Utils/Configurations';
import { RelatorioExecutivo } from 'ebs-orders-reports-react-lib';

import '../Reports.scss';
import ErrorModal from '../../../Components/ErrorModal/ErrorModal';

export default class Executive extends Component {

    constructor() {
        super();

        this.Configurations = new Configurations();
        this._getRelatorioExecutivo = this._getRelatorioExecutivo.bind(this);
        this._getSumarioTemporal = this._getSumarioTemporal.bind(this);
        this.handleOrg = this.handleOrg.bind(this);
        this.handleError = this.handleError.bind(this);
        this.closeErrorModal = this.closeErrorModal.bind(this);

        this.state = {
            // orgSelecionada: 'BSGI@CGESP@CNSP@OESTE@BUTANTÃ@@@BUTANTÃ',
            tabelaExecutivo: [],
            sumarioTemporal: [],
            isLoadingTabela: false,
            isLoadingSumarioTemporal: false,

            hasError: false,
            errorMessage: '',
        };

        this.colors = {
            BS: '#0273bc',
            TC: '#f95553',
            RD: '#f7ce4b',
            BM: '#20b2aa',
            BJ: '#8dc63f'
        };

        this.vehicles = [
            { sigla: "BS", label: "BSP" },
            { sigla: "BJ", label: "BSJ" },
            { sigla: "BM", label: "BS+" },
            { sigla: "TC", label: "TC" },
            { sigla: "RD", label: "RD" }
        ];
    }

    _getRelatorioExecutivo() {
        this.setState({ isLoadingTabela: true })
        const _service = axios.get(this.Configurations.apiBasePath + "/relatorios-lideres/relatorio-executivo?organizacao=" + (this.state.orgSelecionada), { noLoading: true });

        _service.then(response => {
            let _totalTabelaExecutivo = {
                totalLideres: 0,
                assinantesBSMais: 0,
                percAssinantesBSMais: 0,
                naoAssinantesBSMais: 0,
                percNaoAssinantesBSMais: 0,
                nuncaAcessouBSMais: 0,
                percNuncaAcessouBSMais: 0,
                nenhumaAssinatura: 0,
                impressos: 0,
                percNenhumaAssinatura: 0
            };

            if (response.data.data) {
                response.data.data.forEach(item => {
                    _totalTabelaExecutivo.totalLideres += item.totalLideres;
                    _totalTabelaExecutivo.assinantesBSMais += item.assinantesBSMais;
                    _totalTabelaExecutivo.naoAssinantesBSMais += item.naoAssinantesBSMais;
                    _totalTabelaExecutivo.nuncaAcessouBSMais += item.nuncaAcessouBSMais;
                    _totalTabelaExecutivo.nenhumaAssinatura += item.nenhumaAssinatura;
                    _totalTabelaExecutivo.impressos += item.impressos;
                });

                _totalTabelaExecutivo.percAssinantesBSMais = ((_totalTabelaExecutivo.assinantesBSMais) / _totalTabelaExecutivo.totalLideres) * 100;

                _totalTabelaExecutivo.percNaoAssinantesBSMais = ((_totalTabelaExecutivo.naoAssinantesBSMais) / _totalTabelaExecutivo.totalLideres) * 100;

                _totalTabelaExecutivo.percNuncaAcessouBSMais = ((_totalTabelaExecutivo.nuncaAcessouBSMais) / _totalTabelaExecutivo.totalLideres) * 100;

                _totalTabelaExecutivo.percNenhumaAssinatura = ((_totalTabelaExecutivo.nenhumaAssinatura) / _totalTabelaExecutivo.totalLideres) * 100;

            }

            this.setState({
                tabelaExecutivo: response.data.data,
                totalTabelaExecutivo: _totalTabelaExecutivo
            })
        })
            .catch((err) => console.log(err))
            .finally(() => {
                this.setState({ isLoadingTabela: false })
            });
    }

    _getSumarioTemporal() {
        this.setState({ isLoadingSumarioTemporal: true });
        const _service = axios.get(this.Configurations.apiBasePath + "/relatorios-lideres/relatorio-sumario-temporal?organizacao=" + (this.state.orgSelecionada), { noLoading: true });

        _service.then(response => {
            this.setState({
                sumarioTemporal: response.data.sumario
            })
        })
            .catch((err) => console.log(err))
            .finally(() => {
                this.setState({ isLoadingSumarioTemporal: false })
            });
    }

    handleOrg(eValue) {
        this.setState({ isLoadingTabela: true, orgSelecionada: eValue, flagBusca: true, sumarioTemporal: [] },
            () => {
                this._getRelatorioExecutivo();
            }
        );
    }

    handleError(err) { this.setState({ hasError: true, errorMessage: err.message }) }
    closeErrorModal() { this.setState({ hasError: false, errorMessage: "" }) }

    render() {

        const {
            tabelaExecutivo, totalTabelaExecutivo,
            isLoadingSumarioTemporal, sumarioTemporal, isLoadingTabela,
            orgSelecionada, flagBusca,
            hasError, errorMessage
        } = this.state;

        return (
            <div className="carriers-list">
                    <RelatorioExecutivo
                        tabelaExecutivo={tabelaExecutivo}
                        totalTabelaExecutivo={totalTabelaExecutivo}
                        isLoadingTabela={isLoadingTabela}
                        isLoadingSumarioTemporal={isLoadingSumarioTemporal}
                        sumarioTemporal={sumarioTemporal}
                        getSumarioTemporal={this._getSumarioTemporal}
                        colors={this.colors}
                        vehicles={this.vehicles}
                        handleOrg={this.handleOrg}
                        orgSelecionada={orgSelecionada}
                        apiBasePath={this.Configurations.apiBasePath}
                        tokenKey={this.Configurations.tokenKey}
                        flagBusca={flagBusca}
                    />
                <ErrorModal isOpen={hasError} message={errorMessage} closeErrorModal={this.closeErrorModal} />
            </div>
        )
    }
}